﻿import { type LucideIcon } from 'lucide-react';
import { cva, type VariantProps } from 'class-variance-authority';

const orbitIconWrapperVariants = cva('flex size-10 shrink-0 items-center justify-center rounded-lg border ', {
    variants: {
        hover: {
            sidebar:
                'group-hover/menu-button:border-origin-blue group-hover/menu-button:border-2 group-hover/menu-button:bg-(--secondary) group-hover/menu-button:[.dark_&]:bg-origin-blue/20 group-data-[active]/menu-button:border-origin-blue group-data-[active]/menu-button:border-2 group-data-[active]/menu-button:bg-(--secondary) group-data-[active]/menu-button:[.dark_&]:bg-origin-blue/20',
            button: 'group-hover/button:border-origin-blue group-hover/button:border-2 group-hover/button:bg-(--secondary) group-hover/button:[.dark_&]:bg-origin-blue/20',
        },
    },
    defaultVariants: {
        hover: 'sidebar',
    },
});

export type OrbitIconWrapperProps = ({ icon: LucideIcon; imgSrc?: never } | { imgSrc: string; icon?: never }) &
    VariantProps<typeof orbitIconWrapperVariants>;

export function OrbitIconWrapper({ icon: Icon, imgSrc, hover }: OrbitIconWrapperProps) {
    return (
        <div className={orbitIconWrapperVariants({ hover })}>
            {imgSrc ? (
                <img src={imgSrc} alt="" aria-hidden="true" className="size-6 object-contain" />
            ) : (
                Icon && <Icon className="text-origin-blue" />
            )}
        </div>
    );
}
